import React from 'react';
import { Button } from '@material-ui/core';

import SimpleTooltip from '@root/components/tooltips/SimpleTooltip';

const SelectButton = ({ generate, setTabIndex, disabled, customTooltip }) => {
  const generateContent = async () => {
    await generate();
    if (setTabIndex) {
      setTabIndex();
    }
  };
  return (
    <SimpleTooltip
      wrapped
      content={customTooltip}
      placement="left"
      interactive
    >
      <Button
        disabled={disabled}
        onClick={generateContent}
      >
        Select
      </Button>
    </SimpleTooltip>
  );
};

export default SelectButton;
